import { useEffect } from 'react';
import {
  buildInitialMemberTreeExpandState,
  groupMembersByOrgAndGroup,
  mergeNewOrgGroupExpand,
  getMemberExpandKey
} from '../utils/dashboard/memberTreeHelpers';

/**
 * 首次进入自动展开队员树；之后仅合并新增组织/小组
 */
export default function useMemberTreeAutoExpand({
  filteredMembers,
  memberTreeHydratedRef,
  setOpenOrg,
  setOpenGroup,
  setOpenMember
}) {
  useEffect(() => {
    if (!filteredMembers || filteredMembers.length === 0) return;

    if (!memberTreeHydratedRef.current) {
      memberTreeHydratedRef.current = true;
      const { openOrg, openGroup, openMember } = buildInitialMemberTreeExpandState(filteredMembers);
      setOpenOrg(openOrg);
      setOpenGroup(openGroup);
      setOpenMember(openMember);
      console.log('首次自动展开队员树完成');
      return;
    }

    const orgMap = groupMembersByOrgAndGroup(filteredMembers);
    setOpenOrg((prev) => mergeNewOrgGroupExpand(prev, orgMap, 'org'));
    setOpenGroup((prev) => mergeNewOrgGroupExpand(prev, orgMap, 'group'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredMembers]);
  // 列表刷新后清掉已不存在设备的展开态，避免幽灵行卡在「展开却收不回」
  useEffect(() => {
    if (!filteredMembers) return;
    const live = new Set(
      (filteredMembers || []).map((m) => getMemberExpandKey(m)).filter(Boolean)
    );
    setOpenMember((prev) => {
      if (!prev || typeof prev !== 'object') return prev;
      let changed = false;
      const next = {};
      Object.keys(prev).forEach((key) => {
        if (live.has(key)) next[key] = prev[key];
        else changed = true;
      });
      return changed ? next : prev;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredMembers]);

}
